import Constants from '@/Constants';
import React from 'react';
import './style.scss';

const EmptyLessonThumb = () => {
    return (
        <div className="empty-lesson-thumb">
            <i className="material-icons">{Constants.icons.SCHOOL}</i>
        </div>
    );
};

export default EmptyLessonThumb;
